import Layout from "../components/Layout";
import BuyBack from "../components/_BuyBack";

const BuyBackPage = (props:any) => {
    return (
    <Layout>
        <BuyBack />
    </Layout>
    )
}

export default BuyBackPage